<template>
  <div id="wrapper">
    <image-table />
  </div>
</template>

<script>
import ImageTable from '@/mobile/image-table'

export default {
  name: 'CommonImage',
  components: { ImageTable },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss" scoped>
  @import "~@/assets/styles/base";
</style>



// WEBPACK FOOTER //
// src/mobile/searchPage.vue